import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SimyoService } from '../../services/simyo.service';
import { SimyoShoppingCartService } from '../../services/simyo-shopping-cart.service';
import { SimyoDraftService } from '../../services/simyo-draft.service';
import { availableTechnologies, brandPortability, countriesAllowedWithPassport, fiberIndirectTechnologies, orderType, realTechnologyNames, technologyIVTypes, technologyTypes, typeCard } from 'src/app/shared/constantes';
import { iccidValidator } from 'src/app/utils/validators/iccid-validator';
import { NotMustMatch } from 'src/app/utils/validators/not-much-match-validator';
import { MustMatch } from 'src/app/utils/validators/email-confirm-validator';
import { SimyoNormalizadorService } from '../../services/simyo-normalizador.service';
import { SimyoOrderService } from '../../services/simyo-order.service';
import { SimyoRateService } from '../../services/simyo-rate.service';
import { SimyoUserDataService } from '../../services/simyo-user-data.service';
import { SimyoConfirmationService } from '../../services/simyo-confirmation.service';
import { SimyoMovilPackService } from '../../services/simyo-movil-pack.service';
import { DigoService } from 'src/app/services/digo.service';
import { environment } from 'src/environments/environment';
import { HomeService } from "../../../home/services/home.service";
import { HmRateService } from "../../../home/services/hm-rate.service";
import { MatDialog } from '@angular/material/dialog';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserNotFoundComponent } from 'src/app/shared/components/user-not-found/user-not-found.component';
import { SimyoModalWifi5gNoCoverageComponent, SimyoWifi5gNoCoverageResult } from '../simyo-modal-wifi5g-no-coverage/simyo-modal-wifi5g-no-coverage.component';
import { masterAllSimyo } from '../../models/masterAllSimyo';
import { select, Store } from '@ngrx/store';
import { setTotal } from '../redux/simyo.actions';
import { EMPTY, Observable, Subject, Subscription, combineLatest, of } from 'rxjs';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { allPermissions } from 'src/app/shared/permissions';
import { masterAllResponseSimyo } from '../../models/masterAllSimyo';
import { Ipdv } from 'src/app/shared/models/pdvResponse';
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import {isAdult} from '../../../utils/validators/any-form-valid';
import { ZipCodeFormat } from 'src/app/utils/validators/zip-code-validator';
import { HttpErrorResponse } from '@angular/common/http';
import { blankSpaceValidator } from 'src/app/utils/validators/blank-space-validator';
import { SimyoUserDataComponent } from '../simyo-user-data/simyo-user-data.component';
import { catchError, map, pluck, tap, switchMap, take } from 'rxjs/operators';
import { responseReuseIVAccessSimyo } from '../../models/installationVirtual';
import * as moment from 'moment';
import { formatDate } from '@angular/common';
import { SimyoGlobals } from '../../classes/simyo-globals';
import { SimyoAppointmentService } from '../../services/simyo-appointment.service';
import { iuaValidator } from 'src/app/utils/validators/iua-validator';
import { SimyoEvaluateRateService } from '../../services/simyo-evaluate-rate.service';
import { NormalizadorService } from 'src/app/home/services/normalizador.service';
import { SimyoStepperService } from '../../services/simyo-stepper.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
    selector: 'app-simyo',
    encapsulation: ViewEncapsulation.Emulated,
    templateUrl: './simyo.component.html',
    styleUrls: ['./simyo.component.css', '../../../../assets/css/simyo-theme.css'],
    standalone: false
})
export class SimyoComponent implements OnInit, OnDestroy {
    @ViewChild('stepper') stepper: MatStepper;
    @ViewChild('tabUserData') tabUserData: SimyoUserDataComponent;
    @ViewChild('questionPortability') questionPortability;

    public isLoading = false;
    public isEditable = true;
    public finished = false;
    public rate: any;
    public mobileRates: any;
    public bonosSelected: any;
    //public priceBonos: number = 0;
    public muestraNormalizacion = true;
    public typeOrder = '';
    public order;
    public enviroment = environment;
    public pdv: Ipdv;

    // Forms para los steps
    public fibraFormGroup: FormGroup;
    public movilPackFormGroup: FormGroup;
    public movilPackForms: FormArray;
    public clienteFormGroup: FormGroup;
    //public confirmacionFormGroup: FormGroup;
    // Forms para los componentes
    public normalizadorFormGroup: FormGroup;
    public coberturaFormGroup: FormGroup;
    public customerFormGroup: FormGroup;
    public signatureFormGroup: FormGroup;
    private maxAdditionalRates = 5;
    private preventDestroy = false;
    public muestraErrorPeticion = false;
    public msgErrorPeticion: string = null;
    public thereIsCoverage = false;
    public clientIsCover: boolean = false;
    public orderType = orderType;
    public realTechnologyNames = realTechnologyNames;
    public resultadoCoberturaAmena: any;
    public simyo$: Observable<number>;
    public isAdditional: boolean = false;
    public customerInfo: any;
    public allPermissions = allPermissions;
    public orderLoader: any;
    public retryCoverageSubject: Subject<void> = new Subject<void>();
    public technologyTypes = technologyTypes;
    public arrayTechnologyTypes = [...Object.values(technologyTypes)];
    public fiberIndirectTechnologies = fiberIndirectTechnologies;
    public selectedTechnology = technologyTypes.dir;
    public resultadoCobertura: any;
    public orderCreateIsFinished: boolean = false;
    public fibraRateSpeed = '';

    public showTypeContent = '';

    private allSubscription: Subscription[] = [];

    public needResetDocument = false;
    public myAddressResponse;
    public enableMyAddress: boolean = environment.enableMyAddress;
    public showMyAddress: boolean = true;

    private allAdditionalRates: any;
    private allRates;
    public allBonos;
    private msg;
    /** DF-498: evita reabrir el modal WiFi 5G en la misma consulta de cobertura. */
    private wifi5gModalShownForCurrentCheck = false;
    private wifi5gNoCoverageModalRef: NgbModalRef | null = null;
    /** DF-498: el usuario aceptó Contratar WiFi 5G → desbloquea camino a configurador. */
    public wifi5gOfferAccepted = false;

    private zipCode;
    private is_client_active;
    private mobile_can_package;
    private has_max_mobile;
    private has_max_broadband;
    private speed_max_broadband;
    private is_special_300;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private orderService: SimyoOrderService,
        public rateService: SimyoRateService,
        public simyoService: SimyoService,
        private simyoEvaluateRateService: SimyoEvaluateRateService,
        private userDataService: SimyoUserDataService,
        private normalizadorService: SimyoNormalizadorService,
        private confirmationService: SimyoConfirmationService,
        private shoppingCartService: SimyoShoppingCartService,
        private movilPackService: SimyoMovilPackService,
        private draftService: SimyoDraftService,
        private amNormalizadorService: NormalizadorService,
        private digoService: DigoService,
        private homeService: HomeService,
        private hmRateService: HmRateService,
        public dialog: MatDialog,
        private modalService: NgbModal,
        private store: Store<{ simyo: number }>,
        public permSv: PermissionService,
        public simyoGlobals: SimyoGlobals,
        public simyoAppointmentService: SimyoAppointmentService,
        private stepperService: SimyoStepperService,
        private auth: AuthService,
    ) {
        this.shoppingCartService.setShowIcon(true);
        this.simyo$ = store.pipe(select('simyo'));
        this.defineTypeOrder();
    }

    get baseUrl(): string {
        return this.auth.getLegacyBaseUrl();
    }

    ngOnInit(): void {
        this.initComponent();
        this.digoService.keepAlive()
            .subscribe({
                next: (resp: any) => {
                    if (!resp || resp !== 200) {
                        this.digoService.sendDataToLogs('log: Logout de usuario - Logout keepAlive, resp: '+ resp + ' - simyo.component - keepAlive init');
                        this.digoService.goLogin();
                    }
                }
                , error: (error: HttpErrorResponse) => {
                    this.digoService.sendDataToLogs('log: Logout de usuario - Logout keepAlive Error response: '+ error.message + ' - simyo.component - keepAlive init');
                    this.digoService.goLogin();
                }
            });
    }

    ngAfterViewInit() {
        this.shoppingCartService.setStepper(this.stepper);
        this.listenDraftServices();

        if(this.typeOrder == orderType.MOBILE && this.clientIsCover === true  && !this.rateService.getAskPortability()) {
            let onlyPrepaid = countriesAllowedWithPassport.includes(parseInt(this.order?.customer?.nationality_id));
            if( onlyPrepaid && this.order.order_id == null ){
                this.questionPortability.open();
            }
        }
    }

    initComponent() {
        this.allSubscription.push(this.simyoService.getPreventDestroy()
            .subscribe((data: boolean) => {
                this.preventDestroy = data;
            })
        );

        this.allSubscription.push(this.simyoService.getTypeOrder()
            .subscribe((data: any) => {
                if (data) {
                    this.typeOrder = data;
                    this.isAdditional = this.rateService.isAdditional(0, this.customerInfo, this.typeOrder, this.order);
                }
            })
        );

        this.initForms();
        this.getMasters();

        this.allSubscription.push(this.simyoService.getRateFtth()
            .subscribe((data: any) => {
                if (data != null) {
                    this.rate = data;
                    console.log('this.rate -->', this.rate);

                    this.fibraFormGroup.get('rate').patchValue(data);
                    this.orderService.setBroadbandRate(this.rate);
                } else {
                    this.rate = null;
                    this.fibraFormGroup.get('rate').patchValue(null);
                }
            })
        );


        this.allSubscription.push(this.simyoService.getBonus()
            .subscribe((data: any) => {

                this.bonosSelected = data;
                this.orderService.setBonuses(data);
            })
        );

        this.allSubscription.push(this.simyoService.getRatesMobile()
            .subscribe((data: any) => {
                this.mobileRates = data;
                // if (this.mobileRates && this.mobileRates.length && this.mobileRates[0].bonos && this.mobileRates[0].bonos.length) {
                //     this.priceBonos = 0;
                //     this.mobileRates[0].bonos.map(x => this.priceBonos += +x.rate_info.price)
                // }
            })
        );

        this.allSubscription.push(this.normalizadorService.getMuestraNormalizacion()
            .subscribe((value) => {
                this.muestraNormalizacion = value;

                if (this.muestraNormalizacion) {
                    this.customerFormGroup.reset();
                }
            })
        );

        this.allSubscription.push(this.normalizadorService.getResultadoCobertura()
            .subscribe((data: any) => {
                if (data != null) {
                    this.resultadoCobertura = data;
                    // Con fibra neba
                    if
                    (this.resultadoCobertura.get('resultadoConsultaCobertura')?.value?.technology &&
                        this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.technology.length &&
                        this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.technology[0] === technologyTypes.ind_neba &&
                        this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.commercial_deal === null
                    ) {
                        this.simyoService.setNebaNoCommercial(true);
                    }
                    else{
                        this.simyoService.setNebaNoCommercial(false);
                    }


                    if (
                        this.typeOrder === orderType.BROADBAND &&
                        ((this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.technology &&
                        this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.technology.length &&
                        this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.technology[0] === technologyTypes.ind_neba) ||
                        this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.commercial_deal === null)
                    ) {
                        if (!(this.rate && this.resultadoCobertura && !this.customerInfo)) {
                            this.simyoService.setRateFtth(null);
                            this.store.dispatch(setTotal({total: 0}));
                        }
                    }
                    if (
                        this.typeOrder === orderType.CONVERGENT &&
                        ((this.resultadoCobertura.get('resultadoConsultaCobertura')?.value?.technology &&
                        this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.technology.length &&
                        this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.technology[0] === technologyTypes.ind_neba) ||
                        this.resultadoCobertura?.get('resultadoConsultaCobertura')?.value?.commercial_deal === null) &&
                        (this.rate?.rate_info?.speed === '300')
                    ) {
                        this.simyoService.setRateFtth(null);
                        this.store.dispatch(setTotal({total: 0}));
                    }
                    this.orderService.setBroadbandCoverage(data.getRawValue());
                }
            })
        );

        this.allSubscription.push(this.simyoService.getMobilePacks()
            .subscribe((data: any) => {
                if (data != null) {
                    this.orderService.setMobiles(data);
                }
            })
        );

        this.allSubscription.push(this.userDataService.getUserData()
            .subscribe((data: any) => {
                if (data != null) {
                    this.orderService.setUserData(data);
                }
            })
        );

        this.allSubscription.push(this.confirmationService.getFinished()
            .subscribe((data: boolean) => {
                this.finished = data;
                this.shoppingCartService.setOrderFinished(data);
                this.isEditable = !this.finished;
            })
        );

        // Iniciar tramitación desde otra
        this.allSubscription.push(this.simyoService.getUserData()
            .subscribe((data: any) => {
                if (data != null) {
                    this.clienteFormGroup.patchValue(data);
                }
            })
        );

        this.allSubscription.push( this.rateService.getRates()
            .pipe(
                switchMap((data: any) => {
                    if (!data) return of(null);
                    return this.simyoService.getCustomerData().pipe(
                        take(1),
                        switchMap((customerData: any) => {

                        this.zipCode = customerData?.customer?.postal_address?.post_code ?? customerData?.zip_code ?? null;
                        this.is_client_active = customerData?.is_client_active || 0;
                        this.mobile_can_package = customerData?.mobile_can_package || 0;
                        this.has_max_mobile =  customerData?.max_mobile != null ? 1 : 0;
                        this.has_max_broadband =  customerData?.max_broadband != null ? 1 : 0;
                        this.speed_max_broadband =  customerData?.max_broadband?.speed || null;
                        this.is_special_300 = this.simyoService.getIsSpecial300Reduced();

                        if (this.simyoService.getIsNewProcessing() && this.zipCode) {
                            if (this.typeOrder == orderType.CONVERGENT) {
                                let is_portability_other_brand = this.orderService.getIsPortabilityOtherBrand() != null ? brandPortability.digi : null;
                                let provider_id = null;
                                this.simyoService.getSelectedOperator().subscribe(operator => { provider_id = operator?.service_provider_id ?? null;});
                                
                                this.simyoService.setIsNewProcessing(false);
                                return this.rateService.getRatesFromService(this.zipCode, this.typeOrder, this.has_max_mobile, this.has_max_broadband, this.speed_max_broadband, this.is_client_active, this.mobile_can_package, this.is_special_300, is_portability_other_brand, provider_id).pipe(
                                map((result: any) => {
                                    if (result?.msg) {
                                        this.rateService.setRates(result.msg);
                                        return { finalData: result.msg, zipCode: this.zipCode };
                                    }
                                    return { finalData: data, zipCode: this.zipCode };
                                })
                                );
                            }

                            if (this.typeOrder === orderType.MOBILE) {
                                this.simyoService.setIsNewProcessing(false);
                            }

                            return of({ finalData: data, zipCode: this.zipCode });
                            
                        } else {
                            return of({ finalData: data, zipCode: this.zipCode });
                        }
                        })
                    );
                })
            ).subscribe({
                next: ( result) => {
                    if (!result) return;
                    const { finalData } = result;

                    if (finalData) {
                        this.msg = finalData;
                        this.allRates = this.rateService.determineRates(this.msg);
                        this.allAdditionalRates = this.allRates?.ADDITIONALS;
                        this.allBonos = finalData.BONOS;
                    }
                }
            })
        );

        this.allSubscription.push(this.simyoService.getCustomerPromotion()
            .subscribe((data) => {
                this.customerInfo = data;
                this.isAdditional = this.rateService.isAdditional(0, this.customerInfo, this.typeOrder, this.order);
            })
        );

        // Retomar borrador
        this.allSubscription.push(this.simyoService.getFormsData()
            .subscribe((data: any) => {
                if (data != null) {
                    if (data.normalizador != null) {
                        this.normalizadorFormGroup.patchValue(data.normalizador);
                        this.normalizadorService.setFormularioNormalizacion(this.normalizadorFormGroup);
                    }

                    if (data.cobertura != null) {
                        if (!data.haveCoverage) {
                            data.cobertura.resultadoConsultaCobertura = null;
                        }
                        this.coberturaFormGroup.patchValue(data.cobertura);
                        this.normalizadorService.setResultadoCobertura(this.coberturaFormGroup);
                    }

                    if (data.bonuses != null && data.bonuses.length > 0) {
                        this.simyoService.setBonus(data.bonuses);
                    }

                    if (data.fibra != null) {
                        this.updateFormFtth(data.fibra);
                        this.fibraFormGroup.patchValue(data.fibra);

                        // Cobertura/UI antes de evaluar tarifa: si evaluateRateFtth falla, no dejar el form de dirección
                        if (data.haveCoverage) {
                            this.normalizadorService.setMuestraNormalizacion(false);
                            this.normalizadorService.setMuestraBotonNormalizacion(false);
                            this.normalizadorService.setMuestraCobertura(true);
                            if(data.cobertura.resultadoConsultaCobertura.technology.includes(technologyTypes.dir)
                            || data.cobertura.resultadoConsultaCobertura.technology.includes(technologyTypes.ind_vula)) {
                                this.simyoService.setVirtualInstallationData({
                                    gescal37: data.cobertura.resultadoConsultaCobertura.cimaGescalCode,
                                    footprint: data.cobertura.resultadoConsultaCobertura.technology.includes(technologyTypes.dir) ? technologyIVTypes.dir : technologyIVTypes.ind_vula
                                });
                            }
                            this.normalizadorService.setThereIsCoverage(true);
                        } else {
                            this.normalizadorService.setMuestraNormalizacion(true);
                            this.normalizadorService.setMuestraBotonNormalizacion(true);
                            this.normalizadorService.setMuestraCobertura(false);
                            this.normalizadorService.setThereIsCoverage(false);
                        }

                        if (data.fibra.rate && this.allRates?.FTTH_NEW) {
                            const showFtthReduced = (this.orderService.getIsPortabilityOtherBrand() != null) || this.simyoService.getShowFtthReduced();
                            this.simyoEvaluateRateService.evaluateRateFtth(this.allRates, data.fibra.rate, showFtthReduced);
                        } else if (!data.fibra.rate) {
                            this.simyoService.setRateFtth(null);
                        }
                        this.cancelAppointmentBroadband();
                    }

                    if (data.movilPacks != null && data.movilPacks.length > 0 && this.typeOrder !== orderType.BROADBAND) {
                        while (this.movilPackForms.length !== 0) {
                            this.movilPackForms.removeAt(0);
                        }
                        for (let k = 0; k < data.movilPacks.length; k++) {
                            this.movilPackForms.push(this.setMobilePack());
                        }

                        data.movilPacks.forEach((movilPack: any, i: number) => {
                            this.updateFormMobile(movilPack);
                            // Verificar que el control existe antes de intentar acceder
                            if (this.movilPackForms.at(i)) {
                                const movilPackForm = this.movilPackForms.at(i) as FormGroup;
                                movilPackForm.patchValue(movilPack);

                                if (movilPack.rate && this.simyoGlobals.findByKeyInMobile(movilPack.rate, 'rate_info')) {
                                    // movilPack.rate = this.simyoEvaluateRateService.evaluateRateMobile(this.allRates, movilPack.rate, data.fibra);
                                    this.simyoService.setRatesMobile(i,{...movilPack.rate, is_main_line: movilPack.is_main_line} , this.order);
                                }
                                if(movilPack.is_esim == typeCard.esim) {
                                    movilPackForm.get('iccid').patchValue(null);
                                    movilPackForm.get('iccid').clearValidators();
                                }
                                if(movilPack.type_operation == 'portability_change' && data.cliente.account_doctype != 4) {
                                   let customerDonor = movilPack.customer_donor;
                                   let documentType = customerDonor.document_type_id == 4 ? '' : customerDonor.document_type_id;
                                   let documentNumber = customerDonor.document_type_id == 4 ? '' : customerDonor.document_number;
                                   this.clienteFormGroup.patchValue({
                                    portability_origen_name: customerDonor?.name,
                                    portability_origen_lastname: customerDonor?.last_name,
                                    portability_origen_lastname2: '',
                                    portability_origen_birth_date: customerDonor?.birth_date,
                                    portability_origen_doc_type: customerDonor?.document_type_id,
                                    portability_origen_doc: customerDonor?.document_number,
                                    portability_origen_phone: customerDonor?.contact_phone,
                                    portability_origen_email: customerDonor?.email,
                                    portability_origen_nationality_id: customerDonor?.nationality_id
                                   })
                                   movilPackForm.get('customer_donor').patchValue(customerDonor)
                                }

                                this.simyoService.setMobilePacks(i, movilPackForm.getRawValue());
                            }
                        });
                    }

                    if (data.cliente != null) {
                        if (!data.haveCoverage) {
                            data.cliente.nombreVia = '';
                            data.cliente.numero = '';
                            data.cliente.planta = '';
                            data.cliente.puerta = '';
                            data.cliente.escalera = '';
                            data.cliente.codigoPostal = '';
                            data.cliente.localidad = '';
                            data.cliente.provincia = '';
                        }

                        this.clienteFormGroup.patchValue(data.cliente);
                        this.userDataService.setUserData(this.clienteFormGroup.getRawValue());
                    }
                }
            })
        );

        this.allSubscription.push(this.simyoService.getIndexToRemove()
            .subscribe(data => {
                if (data != null) {
                    this.removeAdditionalLine(data);
                }
            })
        );

        this.allSubscription.push(this.draftService.getUpdateDraft()
            .subscribe((update) => {
                if (update) {
                    this.updateOrderWithLastChanges();
                }
            })
        );

        this.allSubscription.push(this.orderService.getOrder()
            .subscribe((order) => {
                this.order = order;
                this.isAdditional = this.rateService.isAdditional(0, this.customerInfo, this.typeOrder, this.order);
            })
        );

        // Errores petición http o direcciones vacias
        this.allSubscription.push(this.normalizadorService.getErrorPeticionCobertura()
            .subscribe((value: any) => {
                this.muestraErrorPeticion = value;
            })
        );

        this.allSubscription.push(this.normalizadorService.getMsgErrorCobertura()
            .subscribe((value: any) => {
                this.msgErrorPeticion = value;
            })
        );

        this.allSubscription.push(combineLatest([this.normalizadorService.getThereIsCoverage(),this.normalizadorService.getClientIsCover()])
            .subscribe(([thereIsCoverage, clientIsCover]: any) => {
                this.thereIsCoverage = thereIsCoverage;
                this.clientIsCover = clientIsCover;
                this.maybeOpenWifi5gNoCoverageModal(thereIsCoverage);

                let viData = this.simyoService.getVirtualInstallationData();
                this.simyoService.setCanVirtualInstallation(false);
                if(this.clientIsCover === true && thereIsCoverage === true && viData.gescal37 !== null) {
                    let clientData = this.clienteFormGroup.value;
                    if (viData.documentNumber == null
                        && clientData.account_doc !== null
                        && clientData.account_doc !== ''
                        && clientData.account_doctype !== null
                        && clientData.account_doctype !== '') {
                        this.simyoService.setVirtualInstallationData({
                            documentNumber: clientData.account_doc,
                            documentType: clientData.account_doctype
                        })
                    }
                }
             
                let cobertura = this.coberturaFormGroup.value?.resultadoConsultaCobertura;
                if((this.typeOrder == orderType.MOBILE || cobertura !== "" && cobertura != null && thereIsCoverage === true) && this.clientIsCover === true  && !this.rateService.getAskPortability()) {
                    if(this.typeOrder ==  orderType.CONVERGENT && this.order.order_id == null && !this.orderService.getIsComesDraft()){
                           this.questionPortability.open();
                    }
                }
            })
        );

        this.allSubscription.push(this.normalizadorService.getClientIsCover()
            .subscribe((value: any) => {
                this.clientIsCover = value;
            })
        );

        this.allSubscription.push(this.digoService.getPDV()
            .subscribe((data: Ipdv) => {
                if (data) {
                    this.pdv = data;
                }
            })
        );

        // this.allSubscription.push(this.simyoService.getCustomerPromotion()
        //     .subscribe((data) => {
        //         this.customerInfo = data;
        //         this.isAdditional = this.rateService.isAdditional(0, this.customerInfo, this.typeOrder, this.order);
        //     })
        // );

        this.allSubscription.push(this.normalizadorService.getResetCoberturaForm()
            .subscribe((data) => {
                if (data === true) {
                    this.coberturaFormGroup.reset();
                    this.normalizadorFormGroup.reset();
                    this.resetComponent();
                }
            })
        );

        this.allSubscription.push(this.simyoService.getCoberturaData()
            .subscribe((data => {
                if(data){
                    this.coberturaFormGroup = data;
                }
            }))
        );

        this.allSubscription.push(this.simyoService.getNormalizadorData()
            .subscribe((data => {
                if(data) {
                    this.normalizadorFormGroup = data;
                }
            }))
        );
    }

    initForms() {
        this.fibraFormGroup = this.formBuilder.group({
            rate: ['', [Validators.required, blankSpaceValidator()]],
            client_iua: [null, [iuaValidator()]]
        });
        this.initMobileForm();

        this.clienteFormGroup = this.formBuilder.group({
            doctype: ['', [Validators.required]],
            doc: ['', [Validators.required, blankSpaceValidator(), Validators.pattern('^[a-zA-Z0-9]+$')]],
            country: ['192', [Validators.required]],
            firstName: ['', [Validators.required, blankSpaceValidator()]],
            surname1: ['', [Validators.required, blankSpaceValidator()]],
            surname2: ['', /*Validators.required*/],
            birthday: ['', [Validators.required, isAdult()]],
            sex: [''/*, Validators.required*/],
            company: [''],
            tipoVia: [''],
            nombreVia: ['', [Validators.required, blankSpaceValidator()]],
            numero: ['', [Validators.required, blankSpaceValidator()]],
            planta: [''],
            puerta: [''],
            escalera: [''],
            bloque: [''],
            codigoPostal: ['', [Validators.required, blankSpaceValidator()]],
            localidad: ['', [Validators.required, blankSpaceValidator()]],
            provincia: ['', [Validators.required]],
            phone: ['', [Validators.required, Validators.pattern('^[67][0-9]{0,8}$'), Validators.minLength(9), Validators.maxLength(9)]],
            email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
            email_confirm: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
            account_types: [''/*, Validators.required*/],
            bill_cicle_types: [''/*, Validators.required*/],
            // Postpago
            acct_code: [''],
            bank_account: [''],
            new_bank_account: [''],
            account_doctype: ['', [Validators.required]],
            account_doc: ['', [Validators.required, blankSpaceValidator(), Validators.pattern('^[a-zA-Z0-9]+$')]],
            account_country: ['', [Validators.required, blankSpaceValidator()]],
            account_firstName: ['', [Validators.required, blankSpaceValidator()]],
            account_surname1: ['', [Validators.required, blankSpaceValidator()]],
            account_surname2: ['', /*Validators.required*/],
            account_company: [''],
            // Prepago
            credit_card_type: [''],
            credit_card_name: [''],
            credit_card_number: [''],
            credit_card_date_of_expiry: [''],
            credit_card_cvv: [''],
            // Delivery address
            office: [''],
            full_name: [''],
            delivery_phone: [''],
            road_type: [''],
            address: [''],
            number: [''],
            floor: [''],
            door: [''],
            stairway: [''],
            zip: [''],
            city: [''],
            province: [''],
            additional_info: [''],
            is_custom_delivery: [''],
            //Portability change contact
            portability_origen_name: [''],
            portability_origen_lastname: [''],
            portability_origen_lastname2: [''],
            portability_origen_birth_date: [''],
            portability_origen_doc_type: [''],
            portability_origen_doc: [''],
            portability_origen_phone: [{value:'', disabled:true}],
            portability_origen_email: [''],
            portability_origen_email_confirm: [''],
            portability_origen_nationality_id: [192]
        }, {
            validators: [MustMatch('email', 'email_confirm'), ZipCodeFormat('codigoPostal'), MustMatch('portability_origen_email', 'portability_origen_email_confirm')]
        });

        /*this.confirmacionFormGroup = this.formBuilder.group({
            fourthCtrl: ['', Validators.required]
        });*/

        // Componentes
        this.normalizadorFormGroup = this.formBuilder.group({
            tipoViaNormaliza: ['', [Validators.required]],
            nombreViaNormaliza: ['', [Validators.required, blankSpaceValidator()]],
            numeroNormaliza: ['', [Validators.required, blankSpaceValidator()]],
            codigoPostalNormaliza: ['', [Validators.required, blankSpaceValidator()]],
            localidadNormaliza: ['', [Validators.required, blankSpaceValidator()]],
            provinciaNormaliza: ['', [Validators.required, blankSpaceValidator()]]
        });

        this.coberturaFormGroup = this.formBuilder.group({
            localidadCobertura: ['', [Validators.required, blankSpaceValidator()]],
            direccionesCobertura: ['', [Validators.required, blankSpaceValidator()]],
            tipoViaCobertura: ['', ''],
            nombreViaCobertura: ['', ''],
            numeroCobertura: ['', ''],
            provinciaCobertura: ['', ''],
            codigoPostalCobertura: ['', ''],
            plantaCobertura: ['', [Validators.required]],
            bisCobertura: [null, ''],
            bloqueCobertura: [null, ''],
            portalCobertura: [null, ''],
            escaleraCobertura: [null, ''],
            tipoPuertaCobertura: [null, ''],
            puertaCobertura: [null, ''],
            resultadoConsultaCobertura: ['', ''],
            numeroApartamento: [''],
            myaddress: [null, '']
        });

        this.customerFormGroup = this.formBuilder.group({
            customer_doctype: ['', [Validators.required]],
            customer_doc: ['', [Validators.required, blankSpaceValidator(), Validators.pattern('^[a-zA-Z0-9]+$')]],
            customer_birthday: [''],
            zip_code: ['', [Validators.required, blankSpaceValidator()]],
            country: [''],
        }, {
            validator: ZipCodeFormat('zip_code')
        });

        this.signatureFormGroup = this.formBuilder.group({
            smsCheck: new FormControl(false),
            smsData: new FormControl(''),
            emailCheck: new FormControl(true),
            emailData: new FormControl(''),
            documentationUploadCheck: new FormControl(false, Validators.requiredTrue),
            documentationUploadType: new FormControl('digital'),
            smsCheckChangeOwner: new FormControl(true),
            smsDataDonor: new FormControl(''),
            smsDataNewOwner: new FormControl(''),

        });
    }

    setMobilePack() {
        return this.formBuilder.group({
            type_operation: ['', [Validators.required]],
            type_pay: ['', [Validators.required]],
            rate: ['', [Validators.required, blankSpaceValidator()]],
            customer_donor: [{}],
            portability_phone: [''],
            portability_operator: [''],
            portability_type_client: [''],
            portability_iccid: [''],
            portability_client: [''],
            portability_date: [''],
            iccid: ['', [Validators.required, iccidValidator(this.digoService), Validators.minLength(19)]],
            terminal: [''],
            terminal_payment_type: [''],
            terminal_insurance: [''],
            stepper_index: [''],
            is_esim: [typeCard.sim, Validators.required],
            discount: [''],
            simyoTVProductCode: [null],
        }, {
            validators: [NotMustMatch('iccid', 'portability_iccid'), NotMustMatch('portability_iccid', 'iccid')]
        });
    }

    addMobilePack() {
        if (this.movilPackForms.length < this.maxAdditionalRates) {
            this.movilPackForms.push(this.setMobilePack());
        }
        this.movilPackService.setAllowAddAdditionalLines(this.movilPackForms.length < this.maxAdditionalRates);
    }

    getMasters() {
        this.simyoService.getProvincesCommunFromService()
            .subscribe((data: any) => {
                if (data && data.msg) {
                    this.simyoService.setProvincesCommun(data.msg);
                }
            });

        this.simyoService.getRoadTypeCommunFromService()
            .subscribe((data: any) => {
                if (data && data.msg) {
                    this.simyoService.setRoadTypesCommun(data.msg);
                }
            });

        this.simyoService.getMasterAllFromService()
            .subscribe((data: masterAllResponseSimyo) => {
                if (data && data.msg) {
                    this.simyoService.setMasterAll(data.msg);
                }
            }, (error) => {
                if (error && error.error && error.error.error && error.error.error.errorCode !== null && error.error.error.errorCode === 462) {
                    this.dialog.open(UserNotFoundComponent, {
                        width: '350px',
                        disableClose: true,
                        data: {
                            marca: 'Simyo'
                          }
                    });
                }
            });
    }

    listenDraftServices() {
        this.allSubscription.push(this.draftService.getMobilePackForms()
            .subscribe((arrayForms) => {
                if (arrayForms.length) {
                    // En lugar de reasignar, actualizar los controles existentes
                    // Limpiar el FormArray actual
                    while (this.movilPackForms.length !== 0) {
                        this.movilPackForms.removeAt(0);
                    }

                    // Agregar los nuevos controles
                    arrayForms.forEach(formGroup => {
                        this.movilPackForms.push(formGroup);
                    });

                    // Actualizar el FormGroup padre si es necesario
                    if (this.movilPackFormGroup) {
                        this.movilPackFormGroup.get('form').setValue(this.movilPackForms.value);
                    }
                }
            })
        );
    }

    defineTypeOrder() {
        if (this.router.url.includes('/simyo/convergente')) {
            this.simyoService.setTypeOrder(orderType.CONVERGENT);
        } else if (this.router.url.includes('/simyo/solo-fibra')) {
            this.simyoService.setTypeOrder(orderType.BROADBAND);
        } else {
            this.simyoService.setTypeOrder(orderType.MOBILE);
        }
    }

    removeAllAdditionalPostpaids(index){
        for (let i = index + 1; i < this.movilPackForms.length; i++) {
            if (this.movilPackForms.controls[i].value.contract_type === 'postpaid') {
                this.simyoService.setIndexToRemove(i);
                //this.orderService.removeOrder(i);
                this.simyoService.removeLine(i);
                i--;
            }
        }
    }

    removeAdditionalLine(index) {
        const value = this.movilPackForms.getRawValue();
        if(index !== 0 || (index == 0 && value.length > 1)) {
            //this.movilPackForms.removeAt(index);
            this.movilPackForms.patchValue(
                value.slice(0, index).concat(
                value.slice(index + 1),
                ).concat(value[index]),
            );
            this.movilPackForms.removeAt(value.length - 1);
        }
        this.movilPackService.setAllowAddAdditionalLines(this.movilPackForms.length < this.maxAdditionalRates);
    }

    // metodo que llamamos antes de guardar un borrador, debería meter todo al order aunque esté a medias
    updateOrderWithLastChanges() {
        if (this.typeOrder !== orderType.BROADBAND) {
            for (const [index, mobileForm] of this.movilPackForms.controls.entries()) {
                // Si tiene tarifa revisamos el formulario para guardarlo en el borrador
                if (mobileForm && mobileForm.get('rate') && mobileForm.get('rate').value && mobileForm.get('rate').value !== '') {
                    // Comprobamos que el iccid es valido y en caso contrario lo eliminamos
                    if (mobileForm.get('iccid').status === 'INVALID') {
                        mobileForm.get('iccid').patchValue('');
                    }
                    // Comprobamos que el portability_iccid es valido y en caso contrario lo eliminamos
                    if (mobileForm.get('portability_iccid').status === 'INVALID') {
                        mobileForm.get('portability_iccid').patchValue('');
                    }
                    // Obtener los datos actuales del formulario
                    const formData = (mobileForm as FormGroup).getRawValue();
                    // Preservar el type_operation original si ya existe en mobilePacks
                    const existingMobilePack = this.simyoService.getMobilePacksObject()[index];
                    if (existingMobilePack && existingMobilePack.type_operation) {
                        formData.type_operation = existingMobilePack.type_operation;
                    }

                    this.simyoService.setMobilePacks(index, formData);
                }
            }
        }

        this.userDataService.setUserData(this.clienteFormGroup.getRawValue());
    }

    changeRate(type) {
        this.rate = null;
        this.simyoService.setIsChanging(true);
        this.stepper.previous();
        this.fibraFormGroup.get('rate').patchValue(null);
        this.showTypeContent = type;

        if (this.isAdditional) {
            this.rateService.setShowRateOnOffer({index: 0, status: false});
        }
    }

    next() {
        if (this.fibraFormGroup.valid) {
            this.stepper.next();
        }
    }

    public onStepChange(stepChange: StepperSelectionEvent) {
        if (this.shouldRevertStepForIncompleteMobileRates(stepChange)) {
            const prev = stepChange.previouslySelectedIndex;
            if (stepChange.selectedStep) {
                stepChange.selectedStep.interacted = false;
            }
            // Asíncrono: un revert síncrono aquí el CDK stepper lo puede sobrescribir y el usuario acaba en Cliente/Confirmación.
            setTimeout(() => {
                if (this.stepper) {
                    this.stepper.selectedIndex = prev;
                    this.stepperService.setCurrentStep(prev);
                }
            }, 0);
            return;
        }

        this.stepperService.setCurrentStep(stepChange.selectedIndex);
        // Actualizar el FormGroup correspondiente al step actual con los datos del mobilePacks
        const firstMobileStepIndex = this.getFirstMobileStepIndex();
        const lastMobileStepIndex = this.getLastMobileStepIndex();
        if (
            this.typeOrder !== orderType.BROADBAND &&
            this.movilPackForms?.length &&
            stepChange.selectedIndex >= firstMobileStepIndex &&
            stepChange.selectedIndex <= lastMobileStepIndex
        ) {
            const mobilePackIndex = stepChange.selectedIndex - firstMobileStepIndex;
            const mobilePacks = this.simyoService.getMobilePacksObject();

            if (mobilePacks && mobilePacks[mobilePackIndex] && this.movilPackForms.controls[mobilePackIndex]) {
                // Actualizar el FormGroup con los datos del mobilePacks correspondiente
                this.movilPackForms.controls[mobilePackIndex].patchValue(mobilePacks[mobilePackIndex]);

                // Verificar si debe cambiar a portability_change basándose en customer_donor
                const formData = mobilePacks[mobilePackIndex];
                if (formData.type_operation === 'portability' && formData.customer_donor &&
                    Object.values(formData.customer_donor).some(val => val !== null && val !== '')) {
                    this.movilPackForms.controls[mobilePackIndex].patchValue({ type_operation: 'portability_change' });
                }

                // Forzar la detección de cambios para que se actualice la UI
                setTimeout(() => {
                    // Trigger change detection para que se actualice la variable typeOperation en el componente
                    const formGroup = this.movilPackForms.controls[mobilePackIndex] as FormGroup;
                    if (formGroup.get('type_operation')) {
                        const typeOperationValue = formGroup.get('type_operation').value;
                        // Emitir un evento para que el componente actualice su variable typeOperation
                        formGroup.get('type_operation').updateValueAndValidity();
                    }
                }, 0);
            }
        }

        if (!this.permSv.hasPermFromV2(allPermissions.others.users_demo)) {
            this.orderCreateIsFinished = false;
            // Se inicializa el valor a 'old' para el flujo antiguo de firma por lo que si tiene permiso del nuevo flujo a priori
            // asignamos el valor como manual y cuando seleccione el tipo de firma se mandará el valor correspondiente
            if (this.order.sign_type === 'old' && this.permSv.hasPermFromV2(allPermissions.simyo.permite_new_signature)) this.orderService.setSignType('digital');

            if (this.digoService.isOpSimyoUser()) this.orderService.setSignType('not_required');

            this.userDataService.setUserData(this.clienteFormGroup.getRawValue());
            this.orderService.setUserData(this.clienteFormGroup.getRawValue())

            this.orderService.createOrder(true, this.permSv.hasPermFromV2(allPermissions.simyo.permite_new_signature) && this.stepper.steps.last === stepChange.selectedStep, this.needResetDocument)
                .subscribe((data: any) => {
                    this.orderCreateIsFinished = true;
                    this.needResetDocument = false;
                    this.orderService.setOrderId(data.msg.orderId);
                }, error => {
                    console.error('[CREATE ORDER]', error);
                    this.orderCreateIsFinished = true;
                });
        }
        // if (stepChange.previouslySelectedIndex > stepChange.selectedIndex) {
        //     stepChange.previouslySelectedStep.interacted = false;
        //    }
    }

    onActivationRequest(event) {
        this.isEditable = event;
    }

    goToHomeRates() {
        this.homeService.setViewBrandRates('am');
        this.hmRateService.setFilterRatesByType(this.orderType.CONVERGENT);
        this.router.navigate(['/']).then(() => this.normalizadorService.resetNormalizacion());
    }

    goToAmenaConvergente() {
        this.amNormalizadorService.setResultadoCobertura(this.resultadoCoberturaAmena);
        this.amNormalizadorService.setMuestraNormalizacion(false);
        this.amNormalizadorService.setMuestraCobertura(false);
        this.amNormalizadorService.setErrorPeticionCobertura(false);

        this.router.navigate(['amena/convergente']);
    }

    setAddress(type) {

        let mockAdress = {"cobertura":null,"googleInfo":{"address_components":[{"long_name":"17","short_name":"17","types":["street_number"]},{"long_name":"Calle de Porfirio","short_name":"C. de Porfirio","types":["route"]},{"long_name":"Tetuán","short_name":"Tetuán","types":["political","sublocality","sublocality_level_1"]},{"long_name":"Madrid","short_name":"Madrid","types":["locality","political"]},{"long_name":"Madrid","short_name":"M","types":["administrative_area_level_2","political"]},{"long_name":"Comunidad de Madrid","short_name":"MD","types":["administrative_area_level_1","political"]},{"long_name":"España","short_name":"ES","types":["country","political"]},{"long_name":"28039","short_name":"28039","types":["postal_code"]}],"formatted_address":"C. de Porfirio, 17, Tetuán, 28039 Madrid, España","geometry":{"location":{"lat":40.462988,"lng":-3.7051667},"viewport":{"south":40.4616472697085,"west":-3.706508980291502,"north":40.4643452302915,"east":-3.703811019708497}},"html_attributions":[]},"ospGeographicAddress":[{"type":"UrbanPropertyAddress","status":"validated","id":null,"ospDwelingId":"28079  5252    17         AL         ","externalIdentifier":[{"name":"ospAddressId","value":"28079  5252    17"},{"name":"ospINECityCode","value":"28079"},{"name":"ospINESingularEntity","value":"280790000"},{"name":"ospINEStreetCode","value":"2807904880"},{"name":"ospINEDistrict","value":"06"},{"name":"numViviendas","value":"1"},{"name":"codViaC","value":"1467488"},{"name":"gescal37","value":"28000010633200017         AL         "},{"name":"codPobC","value":150709}],"href":null,"streetNr":"17","streetNrSuffix":null,"streetNrLast":null,"streetNrLastSuffix":null,"streetName":"PORFIRIO","streetType":"CALLE","streetSuffix":null,"postCode":"28039","locality":null,"city":"MADRID","stateOrProvince":"Madrid","country":"ESP","geographicSubAddress":[{"type":"GeographicSubAddress","status":"validated","id":null,"name":null,"href":null,"subUnitType":null,"subUnitNumber":null,"levelType":null,"buildingName":null,"buildingNameSuffix":null,"stairCase":null,"levelNumber":"AL","doorType":null,"door":null}]}],"ospGeographicAddressTR":{"bis_TR":"","bloque_TR":"","puerta_TR":"","letra_TR":"","escalera_TR":"","planta_TR":"Altillo","mano1_TR":"","mano2_TR":""}};

        let myaddress = {"id":null,"href":null,"ospAddressExternalId":[{"refId":"arvato","externalId":"28079  5252    17"},{"refId":"gescal","externalId":"28000010633200017         AL         "}],"ospAccuracy":null,"streetNr":"17","streetNrSuffix":null,"streetNrLast":null,"streetNrLastSuffix":null,"streetName":"PORFIRIO","streetType":"CALLE","postCode":"28039","locality":null,"city":"MADRID","ospINECityCode":"28079","ospSingularEntity":"280790000","stateOrProvince":"Madrid","country":"SPAIN","staircaseNumber":null,"floorNumber":"AL","apartmentNumber":null,"geocode":null,"geographicSubAddress":[{"type":"GeographicSubAddress","status":"validated","id":null,"name":null,"href":null,"subUnitType":null,"subUnitNumber":null,"levelType":null,"buildingName":null,"buildingNameSuffix":null,"stairCase":null,"levelNumber":"AL","doorType":null,"door":null}],"streetNrSuffix_translation":null};
        const address = new CustomEvent("addrselected", {
            detail: mockAdress,
            bubbles: true,
            cancelable: true,
            composed: true
        });

        this.myAddressSelected(address);


        const auxForm = this.formBuilder.group({
            localidadCobertura: ['MADRID', [Validators.required, blankSpaceValidator()]],
            direccionesCobertura: ['CALLE , PORFIRIO , 17 , 28039', [Validators.required, blankSpaceValidator()]],
            tipoViaCobertura: ['CALLE', ''],
            nombreViaCobertura: ['PORFIRIO', ''],
            numeroCobertura: ['17', ''],
            provinciaCobertura: ['MADRID', ''],
            codigoPostalCobertura: ['28039', ''],
            plantaCobertura: ['Altillo', [Validators.required, blankSpaceValidator()]],
            bisCobertura: [null, ''],
            bloqueCobertura: [null, ''],
            portalCobertura: [null, ''],
            escaleraCobertura: [null, ''],
            tipoPuertaCobertura: [null, ''],
            puertaCobertura: [null, ''],
            resultadoConsultaCobertura: [{
                cimaArvatoCode: "28079  5252    17",
                cimaBisCode: null,
                cimaBlockCode: null,
                cimaGescalCode: "28000010633200017         AL         ",
                cimaINETownCode: "28079",
                cimaPortalCode: null,
                cimaStairCode: null,
                cimaStairOtherCode: null,
                cimaUniqueEntity: null,
                technology: [type],
                commercial_deal: null
            }, ''],
            numeroApartamento: [''],
            myaddress: [myaddress]
        });
        this.normalizadorService.setMuestraCobertura(false);
        this.normalizadorService.setMuestraNormalizacion(false);
        this.normalizadorService.setResultadoCobertura(auxForm);
        if (availableTechnologies.includes(type)) {
            if(type == technologyTypes.dir || type == technologyTypes.ind_vula) {
                this.simyoService.setVirtualInstallationData({
                    gescal37: "28000010633200015         001        ",
                    footprint: type.includes(technologyTypes.dir) ? technologyIVTypes.dir : technologyIVTypes.ind_vula
                });
            }
            this.normalizadorService.setThereIsCoverage(true);
        } else {
            this.normalizadorService.setThereIsCoverage(false);
            this.normalizadorService.setClientIsCover(false);
            this.normalizadorService.setErrorPeticionCobertura(true);
            this.normalizadorService.setMsgErrorCobertura('Lo sentimos, no tienes cobertura de fibra a través de la red de Simyo');
        }
    }
    setAddresTestAppointment(type: any) {
        if (type == 'FIBRA CITAS 1') {
            const auxForm = this.formBuilder.group({
                localidadCobertura: ['CACERES', [Validators.required, blankSpaceValidator()]],
                direccionesCobertura: ['AVENIDA , PABLO NARANJO PORRAS , 3 , 10005', [Validators.required, blankSpaceValidator()]],
                tipoViaCobertura: ['AVENIDA', ''],
                nombreViaCobertura: ['PABLO NARANJO PORRAS', ''],
                numeroCobertura: ['3', ''],
                provinciaCobertura: ['CACERES', ''],
                codigoPostalCobertura: ['10005', ''],
                plantaCobertura: ['Planta 3', [Validators.required, blankSpaceValidator()]],
                bisCobertura: [null, ''],
                bloqueCobertura: [null, ''],
                portalCobertura: [null, ''],
                escaleraCobertura: [null, ''],
                tipoPuertaCobertura: [null, ''],
                puertaCobertura: ['A', ''],
                resultadoConsultaCobertura: [{
                    "cimaArvatoCode": "10037   949     3",
                    "cimaGescalCode": "10000110076100003         003A       ",
                    "cimaINETownCode": "10037",
                    "cimaUniqueEntity": null,
                    "cimaPortalCode": null,
                    "cimaBlockCode": null,
                    "cimaBisCode": null,
                    "cimaStairCode": null,
                    "cimaStairOtherCode": null,
                    "technology": [ "FIBRA DIR" ],
                }, ''],
                numeroApartamento: ['']
            });
            this.amNormalizadorService.setRealtechnology(false);
            this.normalizadorService.setMuestraCobertura(false);
            this.normalizadorService.setMuestraNormalizacion(false);
            this.normalizadorService.setResultadoCobertura(auxForm);
            this.simyoService.setVirtualInstallationData({
                gescal37: "10000110076100003         003A       ",
                footprint: technologyIVTypes.dir
            });
            this.normalizadorService.setThereIsCoverage(true);
        } else {
            const auxForm = this.formBuilder.group({
                localidadCobertura: ['CACERES', [Validators.required, blankSpaceValidator()]],
                direccionesCobertura: ['Calle  , La Higuerilla , 17 , 10004', [Validators.required, blankSpaceValidator()]],
                tipoViaCobertura: ['Calle ', ''],
                nombreViaCobertura: ['La Higuerilla', ''],
                numeroCobertura: ['17', ''],
                provinciaCobertura: ['CACERES', ''],
                codigoPostalCobertura: ['10004', ''],
                plantaCobertura: ['Bajo', [Validators.required, blankSpaceValidator()]],
                bisCobertura: [null, ''],
                bloqueCobertura: [null, ''],
                portalCobertura: ['O1', ''],
                escaleraCobertura: [null, ''],
                tipoPuertaCobertura: [null, ''],
                puertaCobertura: ['B', ''],
                resultadoConsultaCobertura: [{
                    "cimaArvatoCode": "10037  1136    17",
                    "cimaGescalCode": "10000110017700017    O1   BA B       ",
                    "cimaINETownCode": "10037",
                    "cimaUniqueEntity": null,
                    "cimaPortalCode": "O1",
                    "cimaBlockCode": null,
                    "cimaBisCode": null,
                    "cimaStairCode": null,
                    "cimaStairOtherCode": null,
                    "technology": [
                        "FIBRA DIR"
                    ],
                    "commercial_deal": null
                }, ''],
                numeroApartamento: ['']
            });
            this.amNormalizadorService.setRealtechnology(false);
            this.normalizadorService.setMuestraCobertura(false);
            this.normalizadorService.setMuestraNormalizacion(false);
            this.normalizadorService.setResultadoCobertura(auxForm);
            this.simyoService.setVirtualInstallationData({
                gescal37: "10000110017700017    O1   BA B       ",
                footprint: technologyIVTypes.dir
            });
            this.normalizadorService.setThereIsCoverage(true);
        }
    }

    activationLoader(orderLoader) {
        this.orderLoader = orderLoader;
    }

    retryCheckCoverage() {
        this.retryCoverageSubject.next();
    }

    /**
     * DF-498 M3: abre el modal WiFi 5G solo tras consulta sin cobertura de fibra
     * (thereIsCoverage === false), en Fibra/Convergente y con la dirección ya resuelta.
     * No abre si thereIsCoverage es null (error técnico) ni undefined (consultando).
     */
    private maybeOpenWifi5gNoCoverageModal(thereIsCoverage: boolean | null | undefined): void {
        if (thereIsCoverage === undefined) {
            this.wifi5gModalShownForCurrentCheck = false;
            this.wifi5gOfferAccepted = false;
            return;
        }

        if (thereIsCoverage !== false) {
            return;
        }

        if (
            this.wifi5gOfferAccepted ||
            this.wifi5gModalShownForCurrentCheck ||
            this.wifi5gNoCoverageModalRef ||
            this.muestraNormalizacion ||
            (this.typeOrder !== orderType.BROADBAND && this.typeOrder !== orderType.CONVERGENT)
        ) {
            return;
        }

        this.openWifi5gNoCoverageModal();
    }

    private openWifi5gNoCoverageModal(): void {
        this.wifi5gModalShownForCurrentCheck = true;

        this.allSubscription.push(
            this.simyoService.getMasterAll()
                .pipe(take(1))
                .subscribe((master: masterAllSimyo) => {
                    if (this.wifi5gNoCoverageModalRef) {
                        return;
                    }

                    const modalRef = this.modalService.open(SimyoModalWifi5gNoCoverageComponent, {
                        centered: true,
                        size: 'lg',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: 'simyo-wifi5g-modal-window'
                    });
                    this.wifi5gNoCoverageModalRef = modalRef;
                    modalRef.componentInstance.address = this.buildInstallationAddressLabel(master);

                    modalRef.result.then(
                        (result: SimyoWifi5gNoCoverageResult) => {
                            this.wifi5gNoCoverageModalRef = null;
                            this.handleWifi5gNoCoverageModalResult(result);
                        },
                        () => {
                            // X / dismiss: permanece en pantalla de resultado de cobertura
                            this.wifi5gNoCoverageModalRef = null;
                        }
                    );
                })
        );
    }

    private handleWifi5gNoCoverageModalResult(result: SimyoWifi5gNoCoverageResult): void {
        if (result === 'modify-address') {
            this.modifyInstallationAddressFromWifi5gModal();
            return;
        }

        if (result === 'hire-wifi5g') {
            this.acceptWifi5gOfferAndGoToConfigurator();
        }
    }

    /** Misma secuencia que `app-resultado.onEdit()` para volver a consultar dirección. */
    private modifyInstallationAddressFromWifi5gModal(): void {
        this.wifi5gOfferAccepted = false;
        this.wifi5gModalShownForCurrentCheck = false;

        if (this.enableMyAddress) {
            this.normalizadorService.setResetCoberturaForm(true);
        }
        this.normalizadorService.setMuestraCobertura(true);
        this.normalizadorService.setMuestraNormalizacion(true);
        this.normalizadorService.setMuestraBotonNormalizacion(true);
        this.normalizadorService.setErrorPeticionCobertura(false);
        this.normalizadorService.setMsgErrorCobertura(null);
        this.normalizadorService.setThereIsCoverage(false);
    }

    /**
     * Contratar WiFi 5G: cierra el error de sin cobertura y desbloquea el mismo
     * camino post-dirección (cliente → configurador de tarifas) sin fingir fibra.
     */
    private acceptWifi5gOfferAndGoToConfigurator(): void {
        this.wifi5gOfferAccepted = true;
        this.normalizadorService.setErrorPeticionCobertura(false);
        this.normalizadorService.setMsgErrorCobertura(null);
    }

    /** Cobertura fibra real o oferta WiFi 5G aceptada (DF-498). */
    canContinueWithoutFiberCoverage(): boolean {
        return this.thereIsCoverage === true || this.wifi5gOfferAccepted;
    }

    /** Misma composición de dirección que `app-resultado` (texto plano para el modal). */
    private buildInstallationAddressLabel(master?: masterAllSimyo): string {
        const form = this.resultadoCobertura ?? this.coberturaFormGroup;
        if (!form?.get) {
            return '';
        }

        const valueOrEmpty = (controlName: string): string => {
            const raw = form.get(controlName)?.value;
            if (raw == null || raw === '' || raw === 'No tiene' || raw === 'null') {
                return '';
            }
            return String(raw);
        };

        const roadTypes = master?.track_types ?? [];
        const provinces = master?.provinces ?? [];
        const tipoViaRaw = valueOrEmpty('tipoViaCobertura');
        const tipoVia = this.simyoGlobals.getRoadTypeLabel(roadTypes, tipoViaRaw) || tipoViaRaw;
        const nombreVia = valueOrEmpty('nombreViaCobertura');
        const numero = valueOrEmpty('numeroCobertura');
        const plantaRaw = valueOrEmpty('plantaCobertura');
        const planta = plantaRaw
            ? `${plantaRaw.toLowerCase().includes('planta') ? '' : 'Planta '}${plantaRaw}`.trim()
            : '';
        const portal = valueOrEmpty('portalCobertura');
        const bis = valueOrEmpty('bisCobertura');
        const bloque = valueOrEmpty('bloqueCobertura');
        const escalera = valueOrEmpty('escaleraCobertura');
        const tipoPuerta = valueOrEmpty('tipoPuertaCobertura');
        const puerta = valueOrEmpty('puertaCobertura');
        const cp = valueOrEmpty('codigoPostalCobertura');
        const localidad = valueOrEmpty('localidadCobertura');
        const provinciaRaw = valueOrEmpty('provinciaCobertura');
        const provincia = this.simyoGlobals.getProvinceLabel(provinces, provinciaRaw) || provinciaRaw;

        const streetParts = [
            [tipoVia, nombreVia].filter(Boolean).join(' '),
            numero ? `Número ${numero}` : '',
            planta,
            portal ? `Portal ${portal}` : '',
            bis ? `Bis ${bis}` : '',
            bloque ? `Bloque ${bloque}` : '',
            escalera ? `Escalera ${escalera}` : '',
            tipoPuerta ? `Tipo puerta ${tipoPuerta}` : '',
            puerta ? `Puerta ${puerta}` : ''
        ].filter(Boolean);

        const localityParts = [cp, localidad].filter(Boolean).join(' ');
        const provincePart = provincia ? `(${provincia})` : '';

        return [streetParts.join(' '), [localityParts, provincePart].filter(Boolean).join(' ')]
            .filter(Boolean)
            .join(', ');
    }

    changeIsAdditionalIfNeed(fibra) {
        this.isAdditional = this.rateService.isAdditional(0, this.customerInfo, this.typeOrder, this.order, fibra.rate_info.speed);
        this.fibraRateSpeed = fibra.rate_info.speed;
    }

    updateFormFtth(ftth){
        if (ftth?.rate?.rate_info?.contracted_price){
            ftth.rate.rate_info.price = ftth.rate.rate_info.contracted_price;
        }
    }

    updateFormMobile(mobile){
        if (mobile?.rate?.rate_info?.contracted_price){
            mobile.rate.rate_info.real_price = mobile.rate.rate_info.contracted_price;
        }
    }

    ngOnDestroy() {
        if (this.wifi5gNoCoverageModalRef) {
            this.wifi5gNoCoverageModalRef.dismiss('destroy');
            this.wifi5gNoCoverageModalRef = null;
        }
        this.wifi5gOfferAccepted = false;
        this.wifi5gModalShownForCurrentCheck = false;

        if (!this.preventDestroy) {
            this.cancelAppointmentBroadband();
            // Reiniciamos formularios
            this.fibraFormGroup.reset();
            this.initMobileForm();
            this.clienteFormGroup.reset();
            //this.confirmacionFormGroup.reset();
            this.normalizadorFormGroup.reset();
            this.coberturaFormGroup.reset();
            this.customerFormGroup.reset();
            // Reiniciamos varaibles de control
            this.isLoading = false;
            this.isEditable = true;
            this.finished = false;
            this.typeOrder = '';
            // this.priceBonos = 0;
            this.orderLoader = null;
            // Reseteamos info del cliente
            this.simyoService.setDataFromNotCustomer(null);
            this.simyoService.setDataFromCustomer(null);
            this.simyoService.setCustomerPromotion(null);
            this.userDataService.setUserData(null);
            this.normalizadorService.setClientIsCover(false);
            // Reiniciamos normalización
            this.normalizadorService.resetNormalizacion();
            this.normalizadorService.setErrorPeticionCobertura(false);
            this.simyoService.setNebaNoCommercial(false);
            // Reiniciamos pedido
            this.orderService.resetOrder();
            this.simyoService.setRateFtth(null);
            this.simyoService.resetMobile();
            this.simyoService.setBonus([]);
            this.store.dispatch(setTotal({total: 0}));
            this.confirmationService.setFinished(false);
            this.simyoService.setTypeOrder(null);
            this.simyoService.setFormsData(null);
            this.rateService.setShowRateOnOffer({index: 0, status: true});
            this.rateService.setErrorRate(false)
            this.rateService.setErrorRateAdditional(false);
            this.movilPackService.setAllowAddAdditionalLines(true);

            this.simyoService.clearVirtualInstallationData();
            this.simyoService.setCoberturaData(null);
            this.simyoService.setNormalizadorData(null)

            this.orderService.setIsPortabilityOtherBrand(null);

            if (this.stepper) {
                this.stepper.reset();
            }
            if (this.allSubscription && this.allSubscription.length) {
                this.allSubscription.map(subs => subs.unsubscribe());
            }
            this.shoppingCartService.setShowIcon(false);
            this.shoppingCartService.setShow(false);

            this.stepperService.setCurrentStep(0);

            this.rateService.setAskPortability(false);
            this.simyoService.setSelectedOperator(null);
            this.rateService.setRates(null);
        }
    }

    validateUserData() {
        if (this.tabUserData.validate()) {
            this.userDataService.setUserData(this.clienteFormGroup.getRawValue());
        }
        if ( this.tabUserData.terminalDelivery !== undefined) {
            if (!this.clienteFormGroup.get('is_custom_delivery').valid) {
                this.tabUserData.terminalDelivery.errorForm = true;
            } else {
                this.tabUserData.terminalDelivery.errorForm = false;
            }
        }
    }

    /** El stepper incluye paso Fibra (convergente o solo fibra). */
    stepperShowsFibraStep(): boolean {
        return this.typeOrder === orderType.CONVERGENT || this.typeOrder === orderType.BROADBAND;
    }

    /** Flujos con líneas móvil en el stepper (no solo fibra). */
    stepperRequiresCompleteMobileRates(): boolean {
        return this.typeOrder !== orderType.BROADBAND;
    }

    getFirstMobileStepIndex(): number {
        return this.stepperShowsFibraStep() ? 1 : 0;
    }

    getLastMobileStepIndex(): number {
        return this.getFirstMobileStepIndex() + (this.movilPackForms?.length ?? 0) - 1;
    }

    getClienteStepIndex(): number {
        return this.getFirstMobileStepIndex() + (this.movilPackForms?.length ?? 0);
    }

    getConfirmacionStepIndex(): number {
        return this.getClienteStepIndex() + 1;
    }

    /**
     * Todas las líneas del pedido tienen tarifa móvil asignada (alineado con líneas del stepper).
     * En solo fibra no aplica y devuelve true.
     */
    areAllMobileLinesConfigured(): boolean {
        if (!this.stepperRequiresCompleteMobileRates()) {
            return true;
        }
        const expected = this.movilPackForms?.length ?? 0;
        if (expected === 0) {
            return false;
        }
        const mobiles = this.order?.mobiles;
        if (!mobiles || mobiles.length !== expected) {
            return false;
        }
        return mobiles.every(
            (m) =>
                m?.rate != null &&
                typeof m.rate === 'object' &&
                Object.keys(m.rate).length > 0,
        );
    }

    private shouldRevertStepForIncompleteMobileRates(stepChange: StepperSelectionEvent): boolean {
        if (!this.stepperRequiresCompleteMobileRates()) {
            return false;
        }
        const idx = stepChange.selectedIndex;
        if (idx !== this.getClienteStepIndex() && idx !== this.getConfirmacionStepIndex()) {
            return false;
        }
        return !this.areAllMobileLinesConfigured();
    }

    /** Desactiva clics en cabeceras Cliente y Confirmación hasta tener todas las tarifas móviles. */
    shouldGuardClienteConfirmacionStepHeaders(): boolean {
        return this.stepperRequiresCompleteMobileRates() && !this.areAllMobileLinesConfigured();
    }

    onClienteStepLabelClick(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();
        if (!this.stepper) {
            return;
        }
        if (this.areAllMobileLinesConfigured()) {
            this.stepper.selectedIndex = this.getClienteStepIndex();
        }
    }

    onConfirmacionStepLabelClick(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();
        if (!this.stepper) {
            return;
        }
        if (!this.areAllMobileLinesConfigured()) {
            return;
        }
        this.validateUserData();
        this.stepper.selectedIndex = this.getConfirmacionStepIndex();
    }

    getPriceBySpeed(speed) {
        return this.mobileRates[0]?.rate_info ? this.mobileRates[0]?.rate_info[`ftth_${speed}_price`] : '0';
    }

    setUser() {
        this.customerFormGroup.patchValue({
            customer_doctype: '2',
            customer_doc: '12345678Z',
            customer_birthday: formatDate('1991-05-05', 'yyyy-MM-dd', 'en'),
            zip_code: '13700'
        })
    }

    requestResetDocument($event) {
        this.needResetDocument = $event;
    }

    cancelAppointmentBroadband() {
        if(this.order && this.order.draft && this.order.broadband && this.order.broadband.appointment?.id) {
            this.simyoAppointmentService.cancel(this.order.broadband.appointment.id, this.order.order_id).subscribe();
            localStorage.removeItem('appointment');
        }
    }

    myAddressSelected(address){
        this.myAddressResponse = address.detail;
        this.normalizadorFormGroup.reset();
        this.coberturaFormGroup.reset();

        if (address?.detail?.ospGeographicAddress?.length) {
            this.normalizadorFormGroup.patchValue({
                tipoViaNormaliza: address?.detail?.ospGeographicAddress[0]?.streetType,
                nombreViaNormaliza: address?.detail?.ospGeographicAddress[0]?.streetName,
                numeroNormaliza: address?.detail?.ospGeographicAddress[0]?.streetNr,
                codigoPostalNormaliza: address?.detail?.ospGeographicAddress[0]?.postCode,
                localidadNormaliza: address?.detail?.ospGeographicAddress[0]?.city,
                provinciaNormaliza: address?.detail?.ospGeographicAddress[0]?.stateOrProvince
            })

            this.coberturaFormGroup.patchValue({
                rawAddress: address?.detail,
                localidadCobertura: address?.detail?.ospGeographicAddress[0]?.city,
                direccionesCobertura: `${address?.detail?.ospGeographicAddress[0]?.streetType}, ${address?.detail?.ospGeographicAddress[0]?.streetName}, ${address?.detail?.ospGeographicAddress[0]?.streetNr}, ${address?.detail?.ospGeographicAddress[0]?.postCode}`,
                tipoViaCobertura: address?.detail?.ospGeographicAddress[0]?.streetType,
                nombreViaCobertura: address?.detail?.ospGeographicAddress[0]?.streetName,
                numeroCobertura: address?.detail?.ospGeographicAddress[0]?.streetNr,
                provinciaCobertura: address?.detail?.ospGeographicAddress[0]?.stateOrProvince,
                codigoPostalCobertura: address?.detail?.ospGeographicAddress[0]?.postCode,

                bisCobertura: address?.detail?.ospGeographicAddressTR?.bis_TR,
                bloqueCobertura: address?.detail?.ospGeographicAddressTR?.bloque_TR,
                escaleraCobertura: address?.detail?.ospGeographicAddressTR?.escalera_TR,

                // portalCobertura: address?.detail?.ospGeographicAddressTR?.puerta_TR,
                // tipoPuertaCobertura: address?.detail?.ospGeographicAddressTR?.city,
                // numeroApartamento: address?.detail?.ospGeographicAddressTR?.city,

                plantaCobertura: address?.detail?.ospGeographicAddressTR?.planta_TR,
                puertaCobertura: address?.detail?.ospGeographicAddressTR?.puerta_TR !== '' ? address?.detail?.ospGeographicAddressTR?.puerta_TR : address?.detail?.ospGeographicAddressTR?.mano2_TR,

                resultadoConsultaCobertura: address?.detail?.ospGeographicAddressTR?.city,
            });
        }

        if(this.normalizadorFormGroup.valid && this.coberturaFormGroup.valid) {
            this.normalizadorService.setFormularioNormalizacion(this.normalizadorFormGroup);
        } else {
            this.normalizadorService.setMuestraCobertura(false);
        }
    }

    private resetComponent(): void {
        this.showMyAddress = false;
        // Chapuza de manual para reinicar el componente de direcciones
        setTimeout(() => {
            this.showMyAddress = true;
        }, 200);
    }

    public backToFastSearch(status: boolean): void {
        if (status) {
            this.coberturaFormGroup.reset();
            this.normalizadorFormGroup.reset();
        }
    }

    public validateStep(): FormGroup {
        const auxFormGroup: FormGroup = new FormGroup({ejemplo: new FormControl('', Validators.required)});
        return this.fibraFormGroup.valid && this.coberturaFormGroup.valid && this.normalizadorFormGroup.status !== 'INVALID' ? this.fibraFormGroup : auxFormGroup;
    }

    async nextPortability(event: {answer: string, portabilityOperator: any, offerSelected: any}){
        this.rateService.setAskPortability(true);
        this.orderService.setIsPortabilityOtherBrand(event.answer == 'accept' ? event.portabilityOperator.value : null, event.offerSelected);

        let is_portability_other_brand = event.answer == 'accept' ? brandPortability.digi : null;
        let provider_id = null;
        this.simyoService.getSelectedOperator().subscribe(operator => { provider_id = operator?.service_provider_id ?? null;});
        this.is_special_300 = this.simyoService.getIsSpecial300Reduced();

        await this.rateService.getRatesFromService(this.zipCode, this.typeOrder, this.has_max_mobile, this.has_max_broadband, this.speed_max_broadband, this.is_client_active, this.mobile_can_package , this.is_special_300, is_portability_other_brand, provider_id)
            .toPromise()
            .then((data: any) => {
                if (data && data.msg) {
                    this.rateService.setRates(data.msg);
                }
        });
    }

    showWithPortability() {
        if(this.typeOrder !=  orderType.CONVERGENT ||
            (this.typeOrder ==  orderType.CONVERGENT && ((this.rateService.getAskPortability() ||  this.order.order_id !== null))))
            {
            return true;
        }else{
            return false;
        }

    }

    /* OBSOLETO
    comprobarCoberturaDigi(){
        let cobertura = this.coberturaFormGroup.value?.resultadoConsultaCobertura;
        if(cobertura?.technology.length > 0 &&
            (cobertura?.technology.includes('FIBRA DIR') || (cobertura?.technology.some(tech => tech.includes('RRMM')) || cobertura?.commercial_deal?.includes('RRMM')))){
                return true;
        }
        return false;

    }*/

    initMobileForm(){
        let arrayForms = [];
        if (this.typeOrder !== orderType.BROADBAND) {
            arrayForms = [this.setMobilePack()];
        }
        this.movilPackForms = this.formBuilder.array(arrayForms);
        this.movilPackFormGroup = this.formBuilder.group({
            form: this.movilPackForms
        });
    }
}
